{
  "bookButtonLabel": "Book appointment now",
  "bookText": "<h3>Book online:</h3>\n<ul>\n  <li>⏱️  <strong>Quick and easy -</strong> 15 minutes or less</li>\n  <li>🌙  <strong>Book anytime -</strong> even after hours</li>\n  <li>🗓️  <strong>Pick an appointment time that suits you</strong></li>\n  <li>🔐  <strong>No paperwork -</strong> secure and accurate</li>\n</ul>",
  "declineButtonLabel": "Decline this invitation to book now",
  "declineText": "<h3>Not expecting or wanting this procedure?</h3> <p>Let us know by selecting a reason:</p>",
  "helpMessage": "<h3>Prefer to speak with someone?</h3><p>Our friendly team is happy to help:<br/><a><strong>☎️ {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am–5pm.</p>",
  "info": "<h3>Want to know more about this procedure?</h3><p>Watch a short video that explains what to expect and how to prepare.</p>",
  "select": {
    "badTiming": "Timing not convenient",
    "cantAfford": "Can't afford right now",
    "didntKnowReferred": "Didn't know I'd been referred",
    "hadElsewhere": "Have already had elsewhere",
    "notNecessary": "Don't think it's necessary",
    "placeholder": "Select a reason"
  },
  "text": "<p>Your {{requestingPractitioner.practitionerRole}}, <strong>{{requestingPractitioner.displayName}}</strong>, has referred you for a <strong>{{procedure.displayName}}</strong> with <strong>{{practitioners.0.name}}</strong>.</p>",
  "textNoSpecialist": "<p>Your {{requestingPractitioner.practitionerRole}}, <strong>{{requestingPractitioner.displayName}}</strong>, has referred you for a <strong>{{procedure.displayName}}</strong>.</p>",
  "title": "Hi {{patient.nameGiven}}. <br /> It’s time to book your procedure.",
  "videoButtonLabel": "Play video about having an endoscopy procedure",
  "videoCaption": "We recommend watching this video before booking.",
  "videos": {
    "COL": "FKpCAiLuhM01tRghlmeHKuEuJTvjt2kkKitGXJcJN02Xc",
    "GAS": "41GTp01UgOlonZITzkM6Hbo01GadM87pbsNhM00TmEqch4",
    "TNT": "A5Oh2HoSOhkfPxW6cG0197Ev1bbDX014TDM9pNJvNEdxs",
    "fallback": "41GTp01UgOlonZITzkM6Hbo01GadM87pbsNhM00TmEqch4"
  }
}
